import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "section-card" }
const _hoisted_2 = { class: "section-header" }
const _hoisted_3 = { class: "header-left" }
const _hoisted_4 = { class: "stats-bar" }
const _hoisted_5 = { class: "stat-item" }
const _hoisted_6 = { class: "stat-text" }
const _hoisted_7 = { class: "stat-item" }
const _hoisted_8 = { class: "stat-val" }
const _hoisted_9 = { class: "stat-unit" }
const _hoisted_10 = {
  key: 1,
  class: "stat-warn"
}
const _hoisted_11 = { class: "field-card auto-bet-card" }
const _hoisted_12 = { class: "field-header" }
const _hoisted_13 = { class: "field-hint" }
const _hoisted_14 = { class: "field-card auto-bet-card" }
const _hoisted_15 = { class: "field-header" }
const _hoisted_16 = { class: "balance-row" }
const _hoisted_17 = { class: "balance-val" }
const _hoisted_18 = { class: "field-card" }
const _hoisted_19 = { class: "field-hint" }
const _hoisted_20 = { class: "config-grid" }
const _hoisted_21 = { class: "config-card" }
const _hoisted_22 = { class: "config-desc" }
const _hoisted_23 = { class: "config-card" }
const _hoisted_24 = { class: "config-desc" }
const _hoisted_25 = { class: "config-card single" }
const _hoisted_26 = { class: "config-desc" }
const _hoisted_27 = { class: "config-card single" }
const _hoisted_28 = { class: "config-card-header" }
const _hoisted_29 = { class: "config-card single" }
const _hoisted_30 = { class: "config-card-header" }
const _hoisted_31 = { class: "config-card single" }
const _hoisted_32 = { class: "config-card-header" }
const _hoisted_33 = { class: "config-grid" }
const _hoisted_34 = { class: "config-card" }
const _hoisted_35 = { class: "config-desc" }
const _hoisted_36 = { class: "config-card" }
const _hoisted_37 = { class: "config-desc" }
const _hoisted_38 = { class: "whitelist-wrap" }
const _hoisted_39 = { class: "whitelist-header" }
const _hoisted_40 = { class: "whitelist-count" }
const _hoisted_41 = {
  key: 0,
  class: "whitelist-body"
}
const _hoisted_42 = { class: "whitelist-name" }
const _hoisted_43 = {
  key: 1,
  class: "whitelist-empty"
}
const _hoisted_44 = { class: "data-mgmt" }
const _hoisted_45 = { class: "data-mgmt-item" }
const _hoisted_46 = { class: "data-mgmt-item" }

import RoomVO from '@/ts/VO/RoomVO';
import type virtual_blacklist from '@/ts/dbvo/virtual_blacklist';
import type KillPigConfigVO from '@/ts/VO/KillPigConfigVO';
import { NCollapse, NCollapseItem, NInputNumber, NSwitch, NButton, NPopconfirm } from 'naive-ui';
import { inject, ref, computed, type Ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'KillPigControl',
  props: {
    input: {},
    killPigEnabled: { type: Boolean },
    realBalance: {},
    selectRooms: {},
    roomList: {},
    blockList: {}
  },
  emits: ["update:killPigEnabled", "addDealer", "deleteDealer", "clearBetCache", "clearAccountCache"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// 调试模式统一控制所有快捷显示
const debugMode = inject<Ref<boolean>>('debugMode', ref(false));

// 无可用房间时，依赖房间的开关（杀猪 / 保持链接 / 参与门槛）不应被打开
const hasRooms = computed(() => (props.roomList ?? []).length > 0);

// 杀猪（用户当前勾选的房间，selectRooms 实时反映开关状态）或“保持链接”开启时，
// 拉取数据被锁定为开启，遥控器上不可关闭。
// 注意：锁定只看【当前 UI 意图】（selectRooms / AutoBetEnabled），不要依赖 roomList.OpenKillPig——
// 后者只有保存成功后才同步，会出现“关掉杀猪开关但拉取数据仍被锁、需刷新才解锁”的 BUG。
const pullDataLocked = computed(() =>
  !!props.input.AutoBetEnabled ||
  (props.selectRooms?.length ?? 0) > 0);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[15] || (_cache[15] = _createElementVNode("span", { class: "section-title" }, "服务配置", -1)),
        _createElementVNode("span", {
          class: _normalizeClass(["status-badge", _ctx.killPigEnabled ? 'on' : 'off'])
        }, _toDisplayString(_ctx.killPigEnabled ? '运行中' : '已关闭'), 3)
      ]),
      _createVNode(_unref(NSwitch), {
        value: _ctx.killPigEnabled,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (emit('update:killPigEnabled', $event))),
        size: "large",
        disabled: !hasRooms.value
      }, null, 8, ["value", "disabled"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", {
          class: _normalizeClass(["stat-dot", _ctx.killPigEnabled ? 'dot-on' : 'dot-off'])
        }, null, 2),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.killPigEnabled ? '服务运行中' : '服务已暂停'), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        (hasRooms.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.selectRooms.length), 1),
              _createElementVNode("span", _hoisted_9, "/ " + _toDisplayString(_ctx.roomList.length) + " 房间", 1)
            ], 64))
          : (_openBlock(), _createElementBlock("span", _hoisted_10, "无可用房间，相关功能已锁定"))
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _cache[16] || (_cache[16] = _createElementVNode("span", { class: "field-icon" }, "D", -1)),
        _cache[17] || (_cache[17] = _createElementVNode("span", { class: "field-label" }, "拉取数据", -1)),
        _createVNode(_unref(NSwitch), {
          value: _ctx.input.PullDataEnabled,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.input.PullDataEnabled) = $event)),
          disabled: pullDataLocked.value,
          size: "medium",
          style: {"margin-left":"auto"}
        }, null, 8, ["value", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_13, [
        (pullDataLocked.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(" 已锁定：需先关闭相关开关 ")
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_ctx.input.PullDataEnabled ? '已开启：接收上游数据' : '已关闭：已断开连接'), 1)
            ], 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _cache[18] || (_cache[18] = _createElementVNode("span", { class: "field-icon" }, "B", -1)),
        _cache[19] || (_cache[19] = _createElementVNode("span", { class: "field-label" }, "保持链接", -1)),
        _createVNode(_unref(NSwitch), {
          value: _ctx.input.AutoBetEnabled,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.input.AutoBetEnabled) = $event)),
          size: "medium",
          style: {"margin-left":"auto"}
        }, null, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _cache[20] || (_cache[20] = _createElementVNode("span", { class: "balance-label" }, "账号余额", -1)),
        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.realBalance != null ? '¥ ' + _ctx.realBalance.toFixed(2) : '—'), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "field-header" }, [
        _createElementVNode("span", { class: "field-icon" }, "$"),
        _createElementVNode("span", { class: "field-label" }, "参与门槛")
      ], -1)),
      _createVNode(_unref(NInputNumber), {
        value: _ctx.input.KillStartAmount,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.input.KillStartAmount) = $event)),
        "show-button": false,
        min: 0,
        size: "large",
        class: "field-input",
        disabled: !hasRooms.value
      }, null, 8, ["value", "disabled"]),
      _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.input.KillStartAmount === 0 ? '不限制，所有批次均适用' : '参与金额 ≥ ' + _ctx.input.KillStartAmount + ' 元才生效'), 1)
    ]),
    (_unref(debugMode))
      ? (_openBlock(), _createBlock(_unref(NCollapse), { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_unref(NCollapseItem), {
              title: "高级设置",
              name: "advanced"
            }, {
              default: _withCtx(() => [
                _cache[43] || (_cache[43] = _createElementVNode("div", { class: "sub-title" }, "运行参数", -1)),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "config-card-header" }, [
                      _createElementVNode("span", { class: "config-icon" }, "H"),
                      _createElementVNode("span", { class: "config-label" }, "批次启动保护")
                    ], -1)),
                    _createVNode(_unref(NInputNumber), {
                      value: _ctx.input.HeaderReserveJuNumber,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.input.HeaderReserveJuNumber) = $event)),
                      "show-button": false,
                      max: 1000,
                      min: 1,
                      size: "large"
                    }, null, 8, ["value"]),
                    _createElementVNode("span", _hoisted_22, "换主播后前 " + _toDisplayString(_ctx.input.HeaderReserveJuNumber) + " 轮暂不干预", 1)
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "config-card-header" }, [
                      _createElementVNode("span", { class: "config-icon" }, "T"),
                      _createElementVNode("span", { class: "config-label" }, "批次收尾保护")
                    ], -1)),
                    _createVNode(_unref(NInputNumber), {
                      value: _ctx.input.EndReserveJuNumber,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.input.EndReserveJuNumber) = $event)),
                      "show-button": false,
                      max: 1000,
                      min: 2,
                      size: "large"
                    }, null, 8, ["value"]),
                    _createElementVNode("span", _hoisted_24, "至少保留 " + _toDisplayString(_ctx.input.EndReserveJuNumber) + " 轮，保持数据连续", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _cache[24] || (_cache[24] = _createElementVNode("div", { class: "config-card-header" }, [
                    _createElementVNode("span", { class: "config-icon" }, "P"),
                    _createElementVNode("span", { class: "config-label" }, "换主播保护期")
                  ], -1)),
                  _createVNode(_unref(NInputNumber), {
                    value: _ctx.input.DealerSearchStartRange,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.input.DealerSearchStartRange) = $event)),
                    "show-button": false,
                    max: 1000,
                    min: 0,
                    size: "large"
                  }, null, 8, ["value"]),
                  _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.input.DealerSearchStartRange === 0 ? '不限制，所有批次均适用' : '换主播后前 ' + _ctx.input.DealerSearchStartRange + ' 轮暂不干预，避免误判'), 1)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _cache[25] || (_cache[25] = _createElementVNode("span", { class: "config-icon" }, "N", -1)),
                    _cache[26] || (_cache[26] = _createElementVNode("span", { class: "config-label" }, "新批次保护", -1)),
                    _createVNode(_unref(NSwitch), {
                      value: _ctx.input.SkipKillInNewGame,
                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.input.SkipKillInNewGame) = $event)),
                      size: "medium",
                      style: {"margin-left":"auto"}
                    }, null, 8, ["value"])
                  ]),
                  _cache[27] || (_cache[27] = _createElementVNode("span", { class: "config-desc" }, "新批次前三轮暂不干预，保持数据均衡", -1))
                ]),
                _cache[44] || (_cache[44] = _createElementVNode("div", { class: "sub-title" }, "余额推送", -1)),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _cache[28] || (_cache[28] = _createElementVNode("span", { class: "config-icon" }, "¥", -1)),
                    _cache[29] || (_cache[29] = _createElementVNode("span", { class: "config-label" }, "调额后推送", -1)),
                    _createVNode(_unref(NSwitch), {
                      value: _ctx.input.PushBalanceOnAdjust,
                      "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.input.PushBalanceOnAdjust) = $event)),
                      size: "medium",
                      style: {"margin-left":"auto"}
                    }, null, 8, ["value"])
                  ]),
                  _cache[30] || (_cache[30] = _createElementVNode("span", { class: "config-desc" }, "调账后即时推送余额到客户端；关闭则仅落库，需重新登录生效", -1))
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _cache[31] || (_cache[31] = _createElementVNode("span", { class: "config-icon" }, "N", -1)),
                    _cache[32] || (_cache[32] = _createElementVNode("span", { class: "config-label" }, "新账号余额入库", -1)),
                    _createVNode(_unref(NSwitch), {
                      value: _ctx.input.SaveNewUserBalance,
                      "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.input.SaveNewUserBalance) = $event)),
                      size: "medium",
                      style: {"margin-left":"auto"}
                    }, null, 8, ["value"])
                  ]),
                  _cache[33] || (_cache[33] = _createElementVNode("span", { class: "config-desc" }, "新账号入库写入上游余额；关闭则余额存 0", -1))
                ]),
                _cache[45] || (_cache[45] = _createElementVNode("div", { class: "sub-title" }, "保持链接参数", -1)),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _cache[34] || (_cache[34] = _createElementVNode("div", { class: "config-card-header" }, [
                      _createElementVNode("span", { class: "config-icon" }, "I"),
                      _createElementVNode("span", { class: "config-label" }, "间隔(分钟)")
                    ], -1)),
                    _createVNode(_unref(NInputNumber), {
                      value: _ctx.input.AutoBetIntervalMin,
                      "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.input.AutoBetIntervalMin) = $event)),
                      "show-button": false,
                      min: 1,
                      max: 120,
                      size: "large"
                    }, null, 8, ["value"]),
                    _createElementVNode("span", _hoisted_35, "每隔 " + _toDisplayString(_ctx.input.AutoBetIntervalMin) + " 分钟保持一次链接", 1)
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _cache[35] || (_cache[35] = _createElementVNode("div", { class: "config-card-header" }, [
                      _createElementVNode("span", { class: "config-icon" }, "¥"),
                      _createElementVNode("span", { class: "config-label" }, "单注金额")
                    ], -1)),
                    _createVNode(_unref(NInputNumber), {
                      value: _ctx.input.AutoBetAmount,
                      "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.input.AutoBetAmount) = $event)),
                      "show-button": false,
                      min: 0,
                      size: "large"
                    }, null, 8, ["value"]),
                    _createElementVNode("span", _hoisted_37, "每次保持链接下注 " + _toDisplayString(_ctx.input.AutoBetAmount) + " 元", 1)
                  ])
                ]),
                _cache[46] || (_cache[46] = _createElementVNode("div", { class: "sub-title" }, "主播白名单", -1)),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _cache[36] || (_cache[36] = _createElementVNode("span", null, "已添加", -1)),
                    _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.blockList.length) + " 人", 1)
                  ]),
                  (_ctx.blockList.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blockList, (v) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "whitelist-row",
                            key: v.id
                          }, [
                            _createElementVNode("span", _hoisted_42, _toDisplayString(v.dealer_name), 1),
                            _createVNode(_unref(NPopconfirm), {
                              onPositiveClick: ($event: any) => (emit('deleteDealer', v.id!))
                            }, {
                              trigger: _withCtx(() => _cache[37] || (_cache[37] = [
                                _createElementVNode("span", { class: "whitelist-del" }, "删除", -1)
                              ])),
                              default: _withCtx(() => [
                                _createTextVNode(" 确定删除 " + _toDisplayString(v.dealer_name) + " 吗？ ", 1)
                              ]),
                              _: 2
                            }, 1032, ["onPositiveClick"])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_43, "暂无白名单")),
                  _createVNode(_unref(NButton), {
                    size: "small",
                    quaternary: "",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (emit('addDealer'))),
                    class: "add-btn"
                  }, {
                    default: _withCtx(() => _cache[38] || (_cache[38] = [
                      _createTextVNode("+ 添加主播")
                    ])),
                    _: 1
                  })
                ]),
                _cache[47] || (_cache[47] = _createElementVNode("div", { class: "sub-title" }, "数据管理", -1)),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _cache[40] || (_cache[40] = _createElementVNode("div", { class: "data-mgmt-info" }, [
                      _createElementVNode("span", { class: "data-mgmt-label" }, "清空交易数据"),
                      _createElementVNode("span", { class: "data-mgmt-desc" }, "清空后只统计此时间点之后的交易记录")
                    ], -1)),
                    _createVNode(_unref(NButton), {
                      size: "small",
                      type: "warning",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (emit('clearBetCache'))),
                      ghost: ""
                    }, {
                      default: _withCtx(() => _cache[39] || (_cache[39] = [
                        _createTextVNode("清空交易")
                      ])),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _cache[42] || (_cache[42] = _createElementVNode("div", { class: "data-mgmt-info" }, [
                      _createElementVNode("span", { class: "data-mgmt-label" }, "清空账号显示"),
                      _createElementVNode("span", { class: "data-mgmt-desc" }, "清空后只显示此时间点后有交易记录的账号")
                    ], -1)),
                    _createVNode(_unref(NButton), {
                      size: "small",
                      type: "warning",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (emit('clearAccountCache'))),
                      ghost: ""
                    }, {
                      default: _withCtx(() => _cache[41] || (_cache[41] = [
                        _createTextVNode("清空账号")
                      ])),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})